import { EditOutlined } from "@ant-design/icons";
import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";

export const formConfigurationsColumns: TableColumnsType<any> = [
  {
    title: "Formulier",
    dataIndex: "name",
    key: "name",
    render: (_: any, record: any) => (
      <Link to={`/form-configurations/builder/${record.id}`}>
        {record.name}
      </Link>
    ),
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/form-configurations/builder/${record.id}`}>
        <Button icon={<EditOutlined />} variant="light" />
      </Link>
    ),
  },
];
